class HeroSlideshow extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  }

  connectedCallback() {
    this.track = this.querySelector('.hero-slideshow__track');
    this.slides = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-slideshow__dot'));

    if (this.slides.length === 0) return;

    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.dotIndex, 10);
        this.goToSlide(index);
        this.restartAutoplay();
      });
    });

    this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
    this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });

    this.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.pauseAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseAutoplay();
      } else {
        this.startAutoplay();
      }
    });

    this.mobileQuery.addEventListener('change', () => this.updateHeight());

    this.updateHeight();
    this.startAutoplay();
  }

  handleTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
  }

  handleTouchEnd(event) {
    const touchEndX = event.changedTouches[0].clientX;
    const delta = touchEndX - this.touchStartX;
    const threshold = 50;

    if (Math.abs(delta) < threshold) return;

    if (delta < 0) {
      this.goToSlide(this.currentIndex + 1);
    } else {
      this.goToSlide(this.currentIndex - 1);
    }
    this.restartAutoplay();
  }

  goToSlide(index) {
    const total = this.slides.length;
    const newIndex = ((index % total) + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.remove('is-active', 'is-prev');
      const diff = i - newIndex;
      if (diff === 0) {
        slide.classList.add('is-active');
      } else if (diff < 0) {
        slide.classList.add('is-prev');
      }
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === newIndex);
      dot.setAttribute('aria-selected', i === newIndex ? 'true' : 'false');
    });

    this.currentIndex = newIndex;
    this.updateHeight();
  }

  updateHeight() {
    const activeSlide = this.slides[this.currentIndex];
    if (!activeSlide || !this.track) return;

    const ratio = this.mobileQuery.matches
      ? activeSlide.dataset.mobileRatio
      : activeSlide.dataset.desktopRatio;

    if (ratio) {
      this.track.style.aspectRatio = ratio;
    }
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.slides.length < 2) return;
    if (this.reducedMotionQuery.matches) return;

    this.pauseAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.goToSlide(this.currentIndex + 1);
    }, this.autoplaySpeed * 1000);
  }

  pauseAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    this.pauseAutoplay();
    this.startAutoplay();
  }
}

customElements.define('hero-slideshow', HeroSlideshow);